export * from './loyalty-points-meter-widget.styled.default';
